if (!customElements.get('variant-media')) {
  customElements.define(
    'variant-media',
    class VariantMedia extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productInfo = this.closest('product-info');
        this.sliderEl = this.querySelector('[data-product-single-media-slider]');
        this.thumbsEl = this.querySelector('[data-product-single-media-thumbs]');

        this.slidesByVariant = this.groupByVariant(this.sliderEl);
        this.thumbsByVariant = this.groupByVariant(this.thumbsEl);
        this.appliedVariantId = null;

        const visible = this.querySelector('[data-variant-media]:not(.variant-media--hidden)');
        const initialVariantId = visible ? visible.dataset.variantMedia : this.firstVariantId();

        this.querySelectorAll('.variant-media--hidden').forEach((element) => {
          element.classList.remove('variant-media--hidden');
        });

        this.apply(initialVariantId);

        this.onVariantChange = this.handleVariantChange.bind(this);
        if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
          this.unsubscribe = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      groupByVariant(container) {
        const map = new Map();
        if (!container) return map;
        container.querySelectorAll('[data-variant-media]').forEach((element) => {
          const id = element.dataset.variantMedia;
          if (!map.has(id)) map.set(id, []);
          map.get(id).push(element);
        });
        return map;
      }

      firstVariantId() {
        const first = this.slidesByVariant.keys().next();
        return first.done ? null : first.value;
      }

      handleVariantChange(payload) {
        const data = payload?.data;
        if (!data || data.sectionId !== this.sectionId || !data.variant) return;
        this.apply(String(data.variant.id));
      }

      apply(variantId) {
        if (variantId == null) return;
        variantId = String(variantId);
        if (variantId === this.appliedVariantId) return;

        this.syncContainer(this.sliderEl, this.slidesByVariant, this.productInfo?.flkty, this.slidesByVariant.get(variantId) || []);
        this.syncContainer(this.thumbsEl, this.thumbsByVariant, this.productInfo?.flktyNav, this.thumbsByVariant.get(variantId) || []);

        this.refreshFlickity(this.productInfo?.flkty);
        this.refreshFlickity(this.productInfo?.flktyNav);

        this.appliedVariantId = variantId;
      }

      syncContainer(container, groups, flkty, targetElements) {
        if (!container) return;

        if (flkty && flkty.cells) {
          const currentElements = flkty.cells.map((cell) => cell.element);
          const toAdd = targetElements.filter((element) => currentElements.indexOf(element) === -1);
          const toRemove = currentElements.filter((element) => targetElements.indexOf(element) === -1);
          if (toAdd.length) flkty.append(toAdd);
          if (toRemove.length) flkty.remove(toRemove);
        } else {
          targetElements.forEach((element) => container.appendChild(element));
          groups.forEach((elements) => {
            elements.forEach((element) => {
              if (targetElements.indexOf(element) === -1 && element.parentNode) {
                element.parentNode.removeChild(element);
              }
            });
          });
        }
      }

      refreshFlickity(flkty) {
        if (!flkty) return;
        try {
          flkty.select(0, false, true);
          flkty.resize();
        } catch (error) {
          console.warn('variant-media: Flickity refresh skipped:', error);
        }
      }
    }
  );
}
